import { FC } from 'react';
import useToggle from 'react-use/lib/useToggle';
import { ICON_NAMES } from '@belong/types';
import { Button } from '../../actions/Button';
import CollapsibleItem from '../../actions/CollapsibleItem';
import { Icon } from '../../Icon';
import { RegionalCountries } from './RegionalCountries';
import * as styles from './RegionalCountriesList.styles';
import { IRegionalCountriesList, IRegionalList } from './types';

const breakCountriesByRegion = (countries: string[]) => {
  const regions: IRegionalList[] = [];
  let current: IRegionalList | undefined;

  countries.forEach(item => {
    if (item.startsWith('*')) {
      current = { regionName: item.slice(1), countries: [] };
      regions.push(current);
    } else {
      current?.countries.push(item);
    }
  });

  return regions;
};

export const RegionalCountriesList: FC<IRegionalCountriesList> = ({
  countries,
  showCountriesLinkLabel,
  hideCountriesLinkLabel,
  noCollapse = false
}) => {
  const [isCountriesOpened, toggleIsCountriesOpened] = useToggle(false);
  const regionalList = breakCountriesByRegion(countries);

  const countryListToggleLabel = isCountriesOpened ? hideCountriesLinkLabel : showCountriesLinkLabel;

  const regions = (
    <styles.RegionsWrapper className={noCollapse ? 'regional-countries-list' : undefined}>
      {regionalList.map((region: IRegionalList) => {
        return <RegionalCountries key={region.regionName} {...region} />;
      })}
    </styles.RegionsWrapper>
  );

  if (noCollapse) {
    return regions;
  }

  return (
    <styles.Wrapper className="regional-countries-list">
      <Button type="button" variant="quaternary" onClick={toggleIsCountriesOpened} aria-expanded={isCountriesOpened}>
        <styles.CountriesToggleButtonLabel>
          <styles.LabelText>{countryListToggleLabel}</styles.LabelText>
          <Icon name={isCountriesOpened ? ICON_NAMES.ChevronUp : ICON_NAMES.ChevronDown} />
        </styles.CountriesToggleButtonLabel>
      </Button>
      <CollapsibleItem isOpened={isCountriesOpened}>{regions}</CollapsibleItem>
    </styles.Wrapper>
  );
};

RegionalCountriesList.displayName = 'RegionalCountriesList';
